import React, { useState } from "react";

import axios from "../helpers/axios";
import Layout from "../components/global/Layout";

const CreateInvoice = () => {
  const [files, setFiles] = useState([]);

  const onFileChange = (event) => {
    event.preventDefault();

    const files = [];
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      const nameParts = file.name.split(".");
      nameParts.pop();

      files.push({
        name: nameParts.join("."),
        file: file,
        className: "",
      });
    }

    setFiles(files);
  };

  const onUpload = (event) => {
    event.preventDefault();

    files.forEach((file, ix) => {
      const formData = new FormData();

      formData.append("name", file.name);
      formData.append("upload", file.file);

      axios
        .post("/api/invoices/", formData)
        .then(() => {
          files[ix].className = "has-background-success";
        })
        .catch(() => {
          files[ix].className = "has-background-danger";
        })
        .then(() => {
          setFiles(files.map((file) => file));
        });
    });
  };

  return (
    <Layout>
      <div
        className="container"
        style={{
          padding: "2rem",
        }}
      >
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <h1 className="title is-2">Subir facturas</h1>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container mt-5"
        style={{
          padding: "2rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
        }}
      >
        <div className="columns">
          <div className="column is-6">
            <div
              style={{
                position: "relative",
                paddingTop: "50%",
                border: "5px #ccc dashed",
              }}
            >
              <input
                type="file"
                multiple
                onChange={onFileChange}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: 0,
                  cursor: "pointer",
                  zIndex: 1,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "calc(50% - 1rem)",
                  left: 0,
                  width: "100%",
                  textAlign: "center",
                  fontSize: "2rem",
                  color: "#888",
                  fontWeight: "bold",
                  zIndex: 0,
                }}
              >
                Subir facturas
              </div>
            </div>
            <div
              className="button mt-5 is-info is-fullwidth is-large"
              disabled={files.length === 0}
              onClick={onUpload}
            >
              Subir facturas
            </div>
          </div>
          <div className="column is-6">
            <div className="columns is-mobile is-multiline">
              {files.map((file, it) => (
                <div key={it} className="column is-6">
                  <div className={`card ${file.className}`}>
                    <div className="card-content">
                      <div className="media">
                        <div
                          className="media-content"
                          style={{ overflow: "hidden" }}
                        >
                          <p
                            className="title is-4"
                            style={{
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {file.name}
                          </p>
                          <p className="subtitle is-6">{file.file.size}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CreateInvoice;
